import { CardSelectGroup } from './CardSelectGroup'
import { CardSelectItem } from './CardSelectItem'
import { CardSelectItemInput } from './CardSelectItemInput'

CardSelectGroup.Item = CardSelectItem
CardSelectGroup.ItemInput = CardSelectItemInput

export default CardSelectGroup
